/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const EditPencil: React.FC<AllieIconProps> = ({
  size = '20',
  color = 'var(--allie-color-neutral-50)',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6161 6.94454C18.6901 5.8706 18.6901 4.1294 17.6161 3.05546L16.2019 1.64124C15.128 0.567301 13.3868 0.567301 12.3128 1.64124L1.21717 12.7369C0.760569 13.1935 0.479207 13.7962 0.422385 14.4394L0.180299 17.1799C0.0844481 18.2649 0.99248 19.1729 2.0775 19.0771L4.81792 18.835C5.46115 18.7782 6.06387 18.4968 6.52047 18.0402L17.6161 6.94454ZM16.5555 4.11612C17.0436 4.60427 17.0436 5.39573 16.5555 5.88388L15.6058 6.83354L12.4238 3.65156L13.3735 2.7019C13.8616 2.21375 14.6531 2.21375 15.1413 2.7019L16.5555 4.11612ZM11.3632 4.71222L14.5451 7.8942L5.45981 16.9795C5.25227 17.1871 4.9783 17.315 4.68593 17.3408L1.94551 17.5829C1.7905 17.5966 1.66079 17.4669 1.67448 17.3119L1.91657 14.5714C1.94239 14.2791 2.07029 14.0051 2.27783 13.7976L11.3632 4.71222Z"
        fill={color}
      />
    </svg>
  );
};
